import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

import {guestAcquisitionLatestOfferUrl} from "../../../config/constants";

const useStyles = makeStyles((theme: Theme) => createStyles({
  actionButton: {
    [theme.breakpoints.down('md')]: {
      minHeight: 48,
      minWidth: 48,
    },
  },
}));


/** @description Диалог подтверждения принятия условий оферты */
export default function ConfirmationModal({
  handleClose,
  handleAccept,
} : {
  handleClose: () => void,
  handleAccept: () => void,
}) {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Подтверждение принятия условий
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Вы соглашаетесь с&nbsp;условиями публичной оферты
            на&nbsp;подключение сервисов привлечения гостей.
            Ознакомьтесь с&nbsp;условиями{' '}
            <Link
              href={guestAcquisitionLatestOfferUrl}
              target="_blank"
              rel="noreferrer"
              style={{color: 'rgba(37, 80, 255, 1)'}}
            >по&nbsp;ссылке</Link>
            , если не&nbsp;сделали этого ранее.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" className={classes.actionButton}>
            Отмена
          </Button>
          <Button onClick={handleAccept} variant="contained" color="primary" autoFocus className={classes.actionButton}>
            Принять условия
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
